export const filterToOnlyColourProducts = (productList) =>
  productList
    .filter((item) => {
      return item.Colour !== "";
    })
    .reduce((obj, item) => {
      obj[item.ProductIdentifier] = item.Colour;
      return obj;
    }, {});
